var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowOffsite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31 31",
    style: {
      enableBackground: "new 0 0 31 31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#178FEB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "27.3,2.4 7.7,3.5 6.7,3.6 6.8,4.6 7,7.7 7,8.7 8,8.6 19.1,8 5,22.1 8.5,25.6 22.7,11.4 22,22.6  22,23.6 23,23.6 26,23.8 27,23.9 27.1,22.9 28.3,3.5 28.4,2.3  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOffsite);
export default __webpack_public_path__ + "static/media/arrow-offsite.ef15a50780287aee232c89344950865a.svg";
export { ForwardRef as ReactComponent };